import React from 'react';
import styles from './HistoricalDashboardPage.module.scss';
import moment from 'moment';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { HeadTitle } from '../../components/HeadTitle';
import { Label } from '../../components/Label';
import { DateBox } from 'devextreme-react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { TabNav } from '../../components/TabNav';
import { MemoizedHistoricalDashboardEcnGrids } from '../HistoricalDashboardEcnGrids/HistoricalDashboardEcnGrids';
import { MemoizedHistoricalDashboardIdqsGrids } from '../HistoricalDashboardIdqsGrids/HistoricalDashboardIdqsGrids';
import { datePattern } from '../../util/constants';
import { filterDatePattern } from '../../util/orderFilterConstants';
import { PAGE_TAB_ITEMS } from '../../util/dashBoardPageConstants';

const yesterday = moment().subtract(1, 'days');
const TABLE_CONFIG_STORAGE_NAME = 'dashboard_hist_day_trading_grid_pos';

class HistoricalDashboardPage extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      title: 'Day Trading Historical Dashboard',
      tableConfig: JSON.parse(window.localStorage.getItem(TABLE_CONFIG_STORAGE_NAME)) || ['ecn', 'idqs']
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.renderChevRon = this.renderChevRon.bind(this);
  }

  handleDateChange (event, name) {
    // console.log(event.value);
    //  console.log(name);
    let val = event.value;
    this.setState({
      historicDate: val,
      historicDateFormat: val ? moment(val).format(datePattern) : null

    });
  }

  renderGrid (i) {
    const tableConfig = this.state.tableConfig;
    if (tableConfig[i] === 'ecn') {
      return <div className={styles.ecnContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
          content={this.renderChevRon(i)}
        >ECN</Outline><MemoizedHistoricalDashboardEcnGrids historicDateFormat={this.state.historicDateFormat} />
      </div>;
    } else if (tableConfig[i] === 'idqs') {
      return <div className={styles.idqsContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
          content={this.renderChevRon(i)}
        >IDQS</Outline><MemoizedHistoricalDashboardIdqsGrids historicDateFormat={this.state.historicDateFormat} />
      </div>;
    }
  }

  renderTables () {
    const tableConfig = this.state.tableConfig;
    const _this = this;
    return tableConfig.map(function (item, index) {
      return <div key={'dashboard' + item}>{_this.renderGrid(index)}</div>;
    });
  }

  downGrid (i) {
    let tableConfig = [...this.state.tableConfig];
    let temp = tableConfig[i];
    tableConfig[i] = tableConfig[i + 1];
    tableConfig[i + 1] = temp;
    window.localStorage.setItem(TABLE_CONFIG_STORAGE_NAME, JSON.stringify(tableConfig));
    this.setState({ tableConfig: tableConfig }, this.renderTables);
  }

  upGrid (i) {
    let tableConfig = [...this.state.tableConfig];
    let temp = tableConfig[i];
    tableConfig[i] = tableConfig[i - 1];
    tableConfig[i - 1] = temp;
    window.localStorage.setItem(TABLE_CONFIG_STORAGE_NAME, JSON.stringify(tableConfig));
    this.setState({ tableConfig: tableConfig }, this.renderTables);
  }

  renderChevRon (pos) {
    const tableConfigSize = this.state.tableConfig.length;
    if (pos === 0) {
      return <FaArrowDown className={styles.slideArrowUp} onClick={() => this.downGrid(pos)} />;
    } else if (pos === tableConfigSize - 1) {
      return <FaArrowUp className={styles.slideArrowDown} onClick={() => this.upGrid(pos)} />;
    } else {
      return <div key={'arrowOptions'}>
        <FaArrowUp className={styles.slideArrowUp} onClick={() => this.upGrid(pos)} />
        <FaArrowDown className={styles.slideArrowDown} onClick={() => this.downGrid(pos)} />
      </div>;
    }
  }

  render () {
    const historicDateFormat = this.state.historicDateFormat;
    return (
      <div key={'historicDashBoardPage'} >
        <HeadTitle title={this.state.title} />
        <div className={styles.tabControlsContainer}>
          <TabNav tabItems={PAGE_TAB_ITEMS} />
          <div className={styles.dateOptions}>
            <div className={styles.dateSelect}><Label title='Date' /></div>
            <div className={styles.inlineDisplay}>
              <DateBox
                name={'historicDate'}
                value={this.state.historicDate}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={yesterday}
                onValueChanged={this.handleDateChange}
                displayFormat={filterDatePattern} />
            </div>
          </div>
        </div>
        {!historicDateFormat && <div className={styles.errorMessages} id='selectDateError'>Please Select Date</div>}
        {historicDateFormat && <div id='allTablles' >
          {this.renderTables()}
        </div>}
      </div>
    );
  }
}

export default HistoricalDashboardPage;
